// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EquipmentController from "./equipment_controller"
application.register("equipment", EquipmentController)

import ExternalLinkController from "./external_link_controller"
application.register("external-link", ExternalLinkController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import RepresentationController from "./representation_controller"
application.register("representation", RepresentationController)

import TalentCategoriesController from "./talent_categories_controller"
application.register("talent-categories", TalentCategoriesController)
